import React from 'react';
import ExternalLinkItem from 'components/v2/ExternalLinkItem';
export default function ShipmentExternalLink({ id, label, className = '', }) {
    if (!id || !label)
        return null;
    return (React.createElement(ExternalLinkItem, { to: `/shipments/${id}`, label: label, className: className }));
}
